import { render } from "./receiptEditor.vue?vue&type=template&id=5fbbfb92&scoped=true"
import script from "./receiptEditor.vue?vue&type=script&lang=js"
export * from "./receiptEditor.vue?vue&type=script&lang=js"

import "./receiptEditor.vue?vue&type=style&index=0&id=5fbbfb92&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbbfb92"]])

export default __exports__